// extracted by mini-css-extract-plugin
export default {"linkIcon":"ContactTab_linkIcon__-rgzc","noContactsImage":"ContactTab_noContactsImage__cUkPN"};